import React from 'react';
import './styles.css';
import { PageLayout } from '@BUP/components';
import { useTranslation } from 'react-i18next';
import { UserProfile } from './UserProfile';

const ProfilePage = () => {
  const [t] = useTranslation();
  return (
    <PageLayout pageName={t('pages.profile.title')}>
      <div>
        <hr />
        <UserProfile />
      </div>
    </PageLayout>
  );
};

export default ProfilePage;
